import commentLike from "./comment-like";
import replyComment from "./reply-comment";

const loadComments = () => {

// Chargment des commentaires en Ajax

    let xhttp = new XMLHttpRequest();
    let comments = document.getElementById('panel-comments');
    let commentlist = comments.querySelector('.commentlist');

    // Response
    xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != 0) {
                commentlist.innerHTML = this.responseText;
            } else {
                commentlist.innerHTML = "<p>Erreur !?</p>";
            }

        } else {
            commentlist.innerHTML = "<div class='comment-error' >" + this.responseText + "</div>";
        }

        replyComment();
        commentLike();

    };

    xhttp.open("POST", pokaa.ajaxurl, true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("action=load_comments&postid=" + comments.getAttribute('data-postid') + "&nonce=" + comments.getAttribute('data-nonce'));


}

export default loadComments;